import { useBuyOffer as u } from "../../../pages/checkout/api/index.mjs";
const i = () => {
  const { buyOffer: e, isFetching: f } = u();
  return {
    xenditBuyOffer: (r, t) => e(r, t),
    isFetching: f
  };
};
export {
  i as useXenditBuyOffer
};
